import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from './snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  snackBarRef = null;
  constructor(private snackBar: MatSnackBar) {}
  public openSnackBar(message: string, isDesktop, snackType, trackingId?, closeBtnhide = false) {
    this.snackBarRef = this.snackBar.openFromComponent(SnackbarComponent, {
      duration: (trackingId ? 10000 : 3000),
      verticalPosition: isDesktop ? 'top' : 'bottom',
      panelClass: snackType,
      data: { message: message, snackType: snackType, trackingId: trackingId, close: () => this.snackBarRef.dismiss(), closeBtnhide: closeBtnhide },
    });
  }
}
